import React from 'react';

import { DatePicker } from 'antd';
import * as moment from 'moment';

import { isEmpty } from 'util/utils';

import './datepicker.less';

const DatePickerInput = (props) => {
  const { label, required, error, noFuture, noPast, min, max } = props;
  const isInPast = (date) => date < moment().startOf('day');
  const isInFuture = (date) => date > moment().endOf('day');
  const isLowerThan = (date, min) => date < moment(min).startOf('day');
  const isHigherThan = (date, max) => date > moment(max).endOf('day');

  const checkIfDisabled = React.useCallback(
    (date) =>
      (noPast && isInPast(date)) ||
      (noFuture && isInFuture(date)) ||
      (!isEmpty(min) && isLowerThan(date, min)) ||
      (!isEmpty(max) && isHigherThan(date, max)),
    [max, min, noFuture, noPast],
  );

  return (
    <div className={'from-group inputBlock datePickerBlock' + (Boolean(error) && 'error-message')}>
      <label>
        {label} {required && <span className="required-ast">*</span>}
      </label>
      <DatePicker getCalendarContainer={(trigger) => trigger} disabledDate={checkIfDisabled} {...props} />
      {Boolean(error) && <div className="error">{error}</div>}
    </div>
  );
};

export default DatePickerInput;
